import { isMockMode, post, simulateDelay } from "../api";

export const setLicenceExpiration = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Licences/setLicenceExpiration`, data, {
		successMessage: "License expiration set successfully",
	});
};
